import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import Icon, { GLYPHS } from './icon';

class FileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: props.label,
    };

    this.fieldInput = (field) => {
      const handleChange = this.handleChange.bind(this, field);
      // React doesn't accept value prop for input type file
      const { value, ...inputProps } = field.input;
      if (field.accept) {
        inputProps.accept = field.accept;
      }

      return (
        <label className={classnames('c-file-input', field.className)}>
          <div className="c-file-input__empty">
            <Icon glyph={GLYPHS.upload} className="c-icon u-mr--" />
            <span className="u-align-middle">{this.state.label}</span>
          </div>
          <input
            {...inputProps}
            type="file"
            onChange={handleChange}
          />
        </label>
      );
    };
  }

  handleChange(field, e) {
    e.preventDefault();
    const files = e.target.files;
    if (files.length) {
      field.input.onChange(files[0]);
      this.props.onChange(files[0]);
      this.setState({ label: files[0].name });
    }
  }

  render() {
    return (
      <Field
        name={this.props.name}
        accept={this.props.accept}
        component={this.fieldInput}
        className={this.props.className}
      />
    );
  }
}

FileInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  accept: PropTypes.string,
};

FileInput.defaultProps = {
  label: 'Upload a file',
  onChange: () => {},
  className: '',
};

export default FileInput;
